import axios from "axios";
import { getAuthHeaders } from "../../config/auth/auth";

// const { REACT_APP_URL_API } = process.env;
const url: any = process.env.REACT_APP_PUBLIC_SOLUSIPAY_API;

export const Httpimage = axios.create({
  baseURL: url,
  headers: {
    "Content-type": "image/jpeg"
  },
});

Httpimage.interceptors.request.use(
  async (config: any) => {
    // const headers = await getAuthHeaders();
    // console.log(headers)

    return { ...config};
  },
  (error) => Promise.reject(error)
);
